<template>
  <div class="my-payment coming-soon">
    <page-header title="我的缴费" style="margin-bottom: 20px;" />

    <div class="divider">
      <h5>缴费计划</h5>
    </div>
    <ming-table :fields="column" :data="data" />
    <div class="divider">
      <h5>到账记录</h5>
    </div>
    <ming-table :fields="column2" :data="data" />
    <div class="divider">
      <h5>开票情况</h5>
    </div>
    <ming-table :fields="column3" :data="data" />
  </div>
</template>

<script setup>
import PageHeader from '@/components/PageHeader'
import { payPlanColumn, arrivalRecordColumn, invoicingColumn } from './tableColumn'
import { ref } from 'vue'

const column = ref(payPlanColumn)
const column2 = ref(arrivalRecordColumn)
const column3 = ref(invoicingColumn)
const data = ref([])

</script>
